import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PushNotifications } from '@capacitor/push-notifications';
import { UtilService } from '@shared/utils/util';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';
import { Capacitor } from '@capacitor/core';


@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss'],
})
export class NotificationModalComponent implements OnInit {

  public isNative: boolean = this.util.isNative();

  constructor(
    private util: UtilService,
    private modalCtrl: ModalController,
    public platform: Platform,
    private translate: TranslateService,
  ) { }

  ngOnInit() { }
  // Fechar modal
  dismiss() {
    this.modalCtrl.dismiss();
  }

  async enableNotifications() {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping notification setup');
      this.dismiss();
      return;
    }

    try {
      const permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive !== 'granted') {
        const requestResult = await PushNotifications.requestPermissions();

        if (requestResult.receive !== 'granted') {
          NativeSettings.open({
            optionAndroid: AndroidSettings.ApplicationDetails,
            optionIOS: IOSSettings.App
          })
          this.dismiss();
          return;

        } else {
          await this.registerNotifications();
          return;
        }
      } else {
        await this.registerNotifications();
      }
    } catch (error) {
      console.error('Error enabling notifications:', error);
      this.dismiss();
    }
  }

  private async registerNotifications() {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping notification registration');
      return;
    }

    try {
      await PushNotifications.register();
    } catch (err) {
      console.error('Notification registration failed:', err);
    }
  }
}
